var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJudo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "60px",
    height: "60px",
    viewBox: "0 0 36 36",
    "aria-hidden": "true",
    role: "img",
    className: "iconify iconify--twemoji",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E1E8ED",
    d: "M34 6c-2-3-9-4-16-4S3 3 2 5C.093 8.814 1 25 1 26s5 1 5 1V14l1-2v23s3 1 11 1s11-1 11-1V12l1 2v13s5 0 5-1s1.365-16.452-1-20z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#99AAB5",
    d: "M7 27H6V14c0-1 1-2 1-2v15zm23 0h-1V12s1 1 1 2v13z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#66757F",
    d: "M11.781 2l6.281 11.344L24 2L17.891.75z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#CCD6DD",
    d: "M12 .625s2.25-.547 6-.547s6 .547 6 .547V3s-1.625-1-6-1s-6 1-6 1V.625z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#99AAB5",
    d: "M7 35S24.748 3.341 24.748 2.362c0-1-.748-1.737-.748-1.737L7 32v3z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#99AAB5",
    d: "M17.818 14.722s-6.692-11.381-6.692-12.36c0-1 .874-1.737.874-1.737l6.761 12.573l-.943 1.524z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#292F33",
    d: "M7 22s5 2 11 2s11-2 11-2v3s-4 2-11 2s-11-2-11-2v-3z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#292F33",
    d: "M21 24s-2-1-3-1s-3 1-3 1s-1 0-1 1s1 2 1 2s2 1 3 1s3-1 3-1s1-1 1-2s-1-1-1-1z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#292F33",
    d: "M12 33l3 1s1-5 3-7l-2-3s-3 4-4 9zm12 0l-3 1s-1-5-3-7l2-3s3 4 4 9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJudo);
export default __webpack_public_path__ + "static/media/judo.30721a50b8e5c4b610edcf97949d08fb.svg";
export { ForwardRef as ReactComponent };